import { theme as theme$1 } from './dark.mjs';
import { theme } from './light.mjs';
import { theme as theme$2 } from './high_contrast_light.mjs';
import { theme as theme$3 } from './high_contrast_dark.mjs';
import { THEME } from '../utils/constants.mjs';
import { logger } from '../utils/logger.mjs';

const themes = {
    light: theme,
    dark: theme$1,
    high_contrast_light: theme$2,
    high_contrast_dark: theme$3,
};
const childThemes = {
    light: [],
    dark: [],
    high_contrast_light: [],
    high_contrast_dark: [],
};
/** Add a custom theme. */
const addCustomTheme = (theme, children, extend) => {
    var _a;
    themes[theme.name] = theme;
    childThemes[theme.name] = [
        ...children,
        ...Array.from(childThemes[extend]).filter((c) => !children.some(({ prefix }) => prefix === c.prefix)),
    ];
    logger.log(`Added theme "${theme.name}"`);
    (_a = window[THEME]) === null || _a === void 0 ? void 0 : _a.updateTheme();
};
/** Attach a child theme to each theme type. */
const addChildTheme = (
/** Prefix each variable. */
prefix, 
/** A record of each theme type with it's corresponding theme. */
children) => {
    var _a, _b;
    for (const [key, scheme] of Object.entries(children)) {
        (_a = childThemes[key]) === null || _a === void 0 ? void 0 : _a.push({ prefix, scheme });
    }
    logger.log(`Added child theme "${prefix}"`);
    (_b = window[THEME]) === null || _b === void 0 ? void 0 : _b.updateTheme();
};
const loadTheme = (name) => {
    const trueName = name in themes ? name : 'light';
    return [themes[trueName], childThemes[trueName]];
};

export { addChildTheme, addCustomTheme, childThemes, loadTheme, themes };
